import React, { Component } from 'react';
import { Row, Col } from "antd";
import "./index.scss";


class index extends Component {
    render() {
        return (
            <div className="theChart">
                <Row className="title">Revenue % 收入占比</Row>
                <Row>
                    <div id="revenue" style={{ height: 420, width: '100%' }} />
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/revenue.js